/* Core & libraries */
import React, {useEffect, useState} from "react";
import { useTheme } from "react-jss";
import { useLocation, useNavigate } from 'react-router-dom';
import moment from "helpers/moment";

/* Helpers, constants, custom methods, internal libraries */
import { useReportsService  } from "../../../../services/reportsService";
import { useAnalytics } from "../../../../hooks/useAnalytics";
import { PAGE_TITLES } from "../../../../constants/appConstants";

/* Components */
import BookingGrid from "./bookingGrid";
import BookingFilters from "./bookingFilters";

/* Styles */
import styles from "./styles.js"

const BookingsTab = () => {
  const theme = useTheme();
  const classes = styles({ theme });
  const location = useLocation();
  const navigate = useNavigate();
  const { initAnalytics } = useAnalytics();

  const [gridOptions, setGridOptions] = useState(() => {
    const initialPage = location.pathname.includes('/bookings')
      ? new URLSearchParams(location.search).get('page') || 1
      : 1;
    return {
      page: +initialPage,
      bookingStartDate: moment().startOf('year').format("YYYY-MM-DD"),
      bookingEndDate: moment().format("YYYY-MM-DD"),
      travelStartDate: "",
      travelEndDate: ""
    };
  });

  const { bookingsResponse, getBookingsList } = useReportsService();

  const enableDownloadButton = bookingsResponse?.results?.dataItems.length > 0;

  useEffect(() => {
    const initUtagData = {
      channel: 'content',
      pageName: PAGE_TITLES["reports"]
    };
    initAnalytics(initUtagData, 'init call', 'view')
  }, []);

  useEffect(() => {
    getBookingsList(gridOptions);
    gridOptions.page > 1 ? navigate(`/app/reports/bookings?page=${gridOptions.page}`) : navigate(`/app/reports/bookings`)
  }, [gridOptions]);

  const onRowClick = row => {}

  const handleSort = (column, sortDirection) => {
    setGridOptions({
      ...gridOptions,
      sortby: column.id,
      sortdirection: sortDirection === "desc" ? "dsc" : sortDirection,
    });
  };

  return (
    <div className={classes.bookingsTab}>
      <BookingFilters
        response={bookingsResponse}
        gridOptions={gridOptions}
        setGridOptions={setGridOptions}
        type="REPORTS"
        enableDownloadButton={enableDownloadButton}
      />
      <BookingGrid
        bookingsResponse={bookingsResponse}
        gridOptions={gridOptions}
        setGridOptions={setGridOptions}
        onRowClick={onRowClick}
        handleSort={handleSort}
        defaultSort={bookingsResponse?.defaultSort}
      />
    </div>
  )
}

export default BookingsTab;
